import React from 'react'
import { Button } from 'react-bootstrap'
import Carousel from 'react-bootstrap/Carousel';
import { Link } from 'react-router-dom'
import { ASSET_URL } from '../config/config'

const CarouselBanner = () => {
  return (
    <Carousel fade>
      <Carousel.Item>
        <img src={ASSET_URL+'assets/images/sliders/1.webp'} className="w-100 d-block" alt="Banner" />
        <Carousel.Caption>
          <h3>Taking <span> Charge </span> <br></br>of Our Planet</h3>
          <p>Through ATUM Charge, we're empowering our planet with electric vehicles and widespread charging network
            that accelerates the shift to clean transportation. This collective effort curbs climate change, enhances
            air quality, and lays the foundation for a brighter, greener future.</p>
          <Link to="/aboutus"><Button>Know More</Button></Link>
        </Carousel.Caption>
      </Carousel.Item>

      <Carousel.Item>
        <img src={ASSET_URL+'assets/images/sliders/2.webp'} className="w-100 d-block" alt="Banner" />
        <Carousel.Caption>
          <h3><span>Ride Smart </span> <br></br>Charge Smarter</h3>
          <p>Going electric is half the battle won against fossil fuel monopoly. The other half is right here. Ride smart
            and charge smart from a truly sustainable power source – ATUM The World’s 1st Integrated Solar Roof.</p>
          <Link to="/aboutus"><Button>Know More</Button></Link>
        </Carousel.Caption>
      </Carousel.Item>

      <Carousel.Item>
        <img src={ASSET_URL+'assets/images/sliders/3.webp'} className="w-100 d-block" alt="Banner" />
        <Carousel.Caption>
          <h3>Building a <span> Better </span> <br></br>World Together</h3>
          <p>
            The future of our future generations is in our hands. So, let’s leave our planet a little better than we found it.
            Through ATUM Charge, we’re eliminating the need for thermal energy powered EV charging stations and switching to
            a 100% renewable source. We’ve lit the spark of an electric revolution. Join us, won’t you?
          </p>
          <Link to="/aboutus"><Button>Know More</Button></Link>
        </Carousel.Caption>
      </Carousel.Item>
    </Carousel>
  )
}

export default CarouselBanner